<template>
  <div class="font-euclid ">
    <nav 
    :class="$route.path == '/' ? 'bg-white': 'bg-[#e8e6fe]'"
    class=" w-full py-6 px-4 md:px-10">
    <div class="flex justify-between w-full ">
      <div class="" v-if="!user">
              <router-link to="/"><img src="../assets/images/medremindLogoNew.png" alt="MedAlert Logo" class=" h-6 md:h-8 md:ml-12   cursor-pointer"></router-link>
      </div>

      <div v-if="user && $route.path == '/'">
              <router-link to="/dashboard"><img src="../assets/images/medremindLogoNew.png" alt="MedAlert Logo" class=" ml-12 h-auto sm:h-8 cursor-pointer"></router-link>
      </div>

      <div v-if="user && $route.path == '/add-reminder'">
            <img src="../assets/images/medremindLogoNew.png" alt="MedAlert Logo" class=" ml-12 h-auto sm:h-8 cursor-pointer">
      </div>
      
      <div
      :class="!user ? ' flex justify-between w-4/6': 'flex justify-end  w-full'"
      class="  ">
        
        <div v-if="!user" class="md:flex justify-between items-center md:w-5/12 font-medium hidden">
          <a href="#about" class=" hover:cursor-pointer hover:text-medalertBlue">About us</a>
          <a href="#howItWorks" class=" hover:cursor-pointer hover:text-medalertBlue">How it works</a>
          <a href="#contact" class=" hover:cursor-pointer hover:text-medalertBlue">Contact us</a>
        </div>

        <p class=" text-black font-euclid text-base font-medium" v-if="user"> Welcome, <span class="text-medalertBlue">{{user.client.name}}</span  > -  <span> {{user.first_name}}</span> | SMS Units:  <span class="text-medalertBlue">{{user.units_remaining}}</span> </p>

        
        <div v-if="!user" class="flex ml-auto md:ml-0">
           <button @click="loginRouter" type="button" class=" border-2 border-medalertBlue text-white bg-medalertBlue hover:bg-blueHover hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg md:rounded-3xl py-0 text-md px-5 md:px-7 md:py-1 text-center md:mr-0 dark:bg-purple dark:hover:bg-blueHover dark:focus:ring-purple font-euclid">Login</button>
        </div>


      </div>
    </div>
    </nav>
  </div>
</template>

<script>

import {useStore} from 'vuex'
import { computed } from 'vue'
import { ref } from 'vue';
import {useRouter} from 'vue-router'

export default {
  

    name:'navBar',

    setup(){

    const router = useRouter()
    const store = useStore()
    // const userRole = store.state.userRole
    // console.log(userRole)
    const user = store.state.user


    const handleClick = () => {
      store.dispatch('logout')
    }

    const loginRouter = () => {
      router.push('/login')
    }

    return { 
      handleClick,
      // getUserRole,
      // userRole,
      user,
      loginRouter
      // user: computed(() => store.state.user) ,

    }

  },

  mounted(){
      // this.getUserRole();
    }

}
</script>

<style>

</style>